type PurchaseLineCandidate = {
  amountNet?: unknown
  net?: unknown
  vatRate?: unknown
  vat?: unknown
  vatTreatment?: unknown
  vatDeductionMode?: unknown
  deductibleVatPercent?: unknown
  fixedAsset?: unknown
}

const number = (value: unknown): number => Number.isFinite(Number(value)) ? Number(value) : 0
const money = (value: unknown): number => Math.round(number(value) * 100) / 100

const NO_FIXED_ASSET_SIGNIFICANCE_RULE = Object.freeze({
  ruleId: 'NO.TAX.FIXED_ASSET.SIGNIFICANCE.V1',
  effectiveFrom: '2024-01-01',
  threshold: 30000,
  previousThreshold: 15000,
  minimumYears: 3,
  sourceIds: ['NO-LOVDATA-TAX-ACT-14-40', 'NO-TAX-FIXED-ASSETS'],
})

const fixedAssetThresholdForDate = ({ country = 'NO', date }: { country?: unknown; date?: unknown } = {}): number | null => {
  if (String(country).toUpperCase() !== 'NO') return null
  const day = /^\d{4}-\d{2}-\d{2}$/.test(String(date || '')) ? String(date) : NO_FIXED_ASSET_SIGNIFICANCE_RULE.effectiveFrom
  return day >= NO_FIXED_ASSET_SIGNIFICANCE_RULE.effectiveFrom
    ? NO_FIXED_ASSET_SIGNIFICANCE_RULE.threshold
    : NO_FIXED_ASSET_SIGNIFICANCE_RULE.previousThreshold
}

const purchaseLineAcquisitionCost = (line: PurchaseLineCandidate = {}): number => {
  const net = number(line.amountNet ?? line.net)
  if (String(line.vatTreatment || '') === 'vatOnly') return 0
  const vat = String(line.vatTreatment || '') === 'importBasis' ? 0 : net * number(line.vatRate ?? line.vat) / 100
  const mode = String(line.vatDeductionMode || 'full')
  const deductiblePercent = mode === 'none'
    ? 0
    : mode === 'partial'
      ? Math.max(0, Math.min(100, number(line.deductibleVatPercent)))
      : 100
  return money(net + vat * (1 - deductiblePercent / 100))
}

// The amount is only a prompt for review. Whether the line is a fixed asset
// still depends on what was acquired, expected use and the applicable framework.
const shouldShowPurchaseLineAssetChoice = ({ country, date, line = {} }: {
  country?: unknown
  date?: unknown
  line?: PurchaseLineCandidate
} = {}): boolean => {
  if (line.fixedAsset) return true
  const threshold = fixedAssetThresholdForDate({ country, date })
  if (threshold == null) return true
  return purchaseLineAcquisitionCost(line) >= threshold
}

const fixedAssetSignificanceApi = {
  rule: NO_FIXED_ASSET_SIGNIFICANCE_RULE,
  thresholdForDate: fixedAssetThresholdForDate,
  purchaseLineAcquisitionCost,
  shouldShowPurchaseLineAssetChoice,
}

if (typeof window !== 'undefined') window.PlummeFixedAssetSignificance = fixedAssetSignificanceApi
